"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import makeStyles from "../../theming/make-styles.js";
import Avatar from "./avatar.js";
const useStyles = makeStyles()((theme, { color }) => {
    const palette = theme.palette(color).avatar;
    return {
        avatar: {
            marginLeft: `-${theme.spacing("sm")}`,
            border: `${theme.size(2)} solid ${palette.group.borderColor}`,
        },
        group: {
            display: "inline-flex",
            flexDirection: "row-reverse",
            alignItems: "center",
        },
    };
});
export const AvatarGroup = React.forwardRef(function AvatarGroup(_a, ref) {
    var { children, className, color = "primary", max = 5, size = "medium" } = _a, props = __rest(_a, ["children", "className", "color", "max", "size"]);
    const { classes, cx } = useStyles({ color });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = React.Children.map(children, (child, index) => {
        return (!!child &&
            React.cloneElement(child, Object.assign(Object.assign({ color: child.props.name ? color : "gray", size }, child.props), { key: index, className: cx(classes.avatar, child.props.className) })));
    });
    const remaining = items && (items === null || items === void 0 ? void 0 : items.length) - max;
    return (_jsxs("div", Object.assign({ ref: ref, className: cx(classes.group, className), "data-component": "avatar-group" }, props, { children: [items && (items === null || items === void 0 ? void 0 : items.length) > max && _jsx(Avatar, { className: classes.avatar, color: "gray", name: `+ ${remaining}`, size: size }), items === null || items === void 0 ? void 0 : items.slice(0, max).reverse()] })));
});
export default AvatarGroup;
//# sourceMappingURL=avatar-group.js.map